import { useState, useEffect, useCallback, useMemo, useReducer } from "react";

const initialState = { simpleNumber: 0 };

function reducer(state, action) {
  switch (action.type) {
    case 'add':
      return { simpleNumber: state.simpleNumber + 1 };
    case 'subtract':
      return { simpleNumber: state.simpleNumber - 1 };
    case 'reset':
      return { simpleNumber: 0 };
    default:
      throw new Error('Unknown action type');
  }
};

function TemplateScreen() {

  const [state, dispatch] = useReducer(reducer, initialState);
  const [simpleNumber, setSimpleNumber] = useState(0);

  useEffect(() => {
    console.log("Update:", state.simpleNumber);
  }, [state.simpleNumber]);

  // useEffect(() => {
  //   console.log("Update:", simpleNumber);
  // }, [simpleNumber]);

  const computedValue = useMemo(() => {
    return state.simpleNumber * 2;
  }, [state.simpleNumber]);

  // const computedValue = useMemo(() => {
  //   return simpleNumber * 2;
  // },[simpleNumber]);

  // const add = useCallback(() => {
  //   setSimpleNumber(prev => prev + 1);
  // },[simpleNumber]);

  // const subtract = useCallback(() => {
  //   setSimpleNumber(prev => prev - 1);
  // },[simpleNumber]);

  // const reset = useCallback(() => {
  //   setSimpleNumber(0);
  // },[simpleNumber]);

  return (
    <div style={styles.mainContainer}>
      <h1>{`Uncalculated: ${state.simpleNumber}`}</h1>
      <h2>{`Calculated: ${computedValue}`}</h2>
      {/* 
        Dispatch itself is already stable and doesn't change 
        unless the component itself re-renders. 
        React guarantees that dispatch from useReducer 
        is the same function across renders
      */}
      <button style={styles.addButton} onClick={() => dispatch({ type: 'add' })}>ADD</button>
      <button style={styles.subtractButton} onClick={() => dispatch({ type: 'subtract' })}>SUBTRACT</button>
      <button style={styles.resetButton} onClick={() => dispatch({ type: 'reset' })}>RESET</button>
    </div>
  );
}
const styles = {
  buttonValue: {
    color: "#ffffff",
    fontWeight: "bold",
  },
  addButton: {
    width: 100,
    height: 50,
    backgroundColor: "green",
    color: 'white',
    fontWeight: 'bold'
  },
  subtractButton: {
    width: 100,
    height: 50,
    backgroundColor: "red",
    color: 'white',
    fontWeight: 'bold'
  },
  resetButton: {
    width: 100,
    height: 50,
    backgroundColor: "blue",
    color: 'white',
    fontWeight: 'bold'
  },
  mainContainer: {
    display: "flex",
    width: "100%",
    height: "100vh",
    border: "3px solid red",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
};
export default TemplateScreen;
